import * as Config from '../../../../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import DragItem from '../../../../dnd/DragItem';
import Column from '../../Column';
import ColumnChecker from '../../ColumnChecker';
import ColumnActions from '../../ColumnActions';
import ColumnUpgrade from '../../ColumnUpgrade';
import ColumnCover from '../../ColumnCover';
import ColumnTrack from '../../ColumnTrack';
import ColumnLabel from '../../ColumnLabel';
import ColumnGenre from '../../ColumnGenre';
import ColumnBpmKey from '../../ColumnBpmKey';
import ColumnMore from '../../ColumnMore';
import ColumnDate from '../../ColumnDate';
import ColumnTime from '../../ColumnTime';
import ColumnRemixer from '../../ColumnRemixer';

import useTrackAccess from '../../hooks/useTrackAccess';

// React.memo(
const ConnectedRowShared = ({
  item, index, width, height, className = 'item', style,
  isSortable,
  idParent, onClick,
  end,
  onLoadMore,
  isTablet
}) => {

  const {
    isEnabled,
    playerLoadSong,
    previewPlayer, isPreview, stylePreview,
    beginDnD, showContextMenu, ContextMenuContent,
  } = useTrackAccess(item, idParent, index);
  const onClickRow = (e) => onClick(item, e, index);

  const RSizeChecker = 10;
  const RSizeNumber = 5;
  const RSizeActions = isTablet ? 90: 50;
  const RSizeCover = 45;
  const RSizeMore = 35;
  const RSizeKey = 90;
  const RSizeRelease = 75;
  const RSizeTime = 50;
  const RSizeFan = 80;

  const RTotal = RSizeChecker + RSizeNumber + RSizeActions + RSizeCover + RSizeMore + RSizeKey + RSizeRelease + RSizeTime + RSizeFan;
  let RSizeTrack = ((width - RTotal) * 30 / 100);
  let RSizeRemixer = ((width - RTotal) * 20 / 100);
  let RSizeLabel = ((width - RTotal) * 25 / 100);
  let RSizeGenre = ((width - RTotal) * 25 / 100);
  RSizeTrack += (Config.LIST_HEADER_HAS_REMIXER) ? 0 : RSizeRemixer;

  return (
    <>
      <DragItem type={isEnabled ? `TRACK` : `X`} idParent={idParent} begin={beginDnD} end={end} onClick={onClickRow} ContextMenuContent={ContextMenuContent} onMouseEnter={onLoadMore ? onLoadMore(index) : null} item={item} className={`${isPreview && `preview`} ${className} ${!isEnabled && `disabled`} `} style={stylePreview({ width, height })}>
        <ColumnChecker width={RSizeChecker} isDisabled={false} trackID={item.id} value={null} />
        <Column className={`type-small`} style={{ width: RSizeNumber, textAlign: `center` }} value={``} />
        <ColumnActions width={RSizeActions} keyID={item.id} isPreview={false} isTablet={isTablet}
            onClickPlayDeckA={playerLoadSong(1)} onClickPlayDeckB={playerLoadSong(2)} />
        <ColumnCover width={RSizeCover} item={item} previewPlayer={previewPlayer} />
        <ColumnTrack width={RSizeTrack} item={item} includeRemixers={false} containerStyle={{ marginRight: 10 }}  />
        { (Config.LIST_HEADER_HAS_REMIXER) && (
          <ColumnRemixer width={RSizeRemixer} remixers={item.remixers} />
        )}
        <ColumnLabel width={RSizeLabel - 8} item={item} style={{ marginRight: 8 }}  />
        <ColumnGenre width={RSizeGenre} item={item} />
        <ColumnBpmKey width={RSizeKey} item={item} />
        { isEnabled ? (
          <>
            <ColumnDate width={RSizeRelease} date={item.release} />
            <ColumnTime width={RSizeTime} duration={item.length} durationMs={item.length_ms} />
            <div className={`request-by`} style={{width: RSizeFan}}>
              <span className={`ellipsis type-placeholder`} style={{width: `90%`, display: `inline-block`}}>{(item.requestby) && item.requestby}</span>
            </div>
            <ColumnMore width={RSizeMore} id={item.id} onClick={showContextMenu} />
          </>
        ) : (
          <ColumnUpgrade width={RSizeRelease + RSizeTime + RSizeMore} />
        )}
      </DragItem>
    </>
  )
};

ConnectedRowShared.propTypes = {
  item: PropTypes.object.isRequired,
  idParent: PropTypes.any,
  index: PropTypes.number.isRequired,
  width: PropTypes.any.isRequired,
  height: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  end: PropTypes.func,
  isSortable: PropTypes.bool
}

const RowShared = connect(
  state => ({
    isTablet: state.layoutTablet
  })
)(ConnectedRowShared);

export default RowShared;
